// components/Sun.jsx - 太阳组件（代表个人）
import React, { useRef, useState } from 'react';
import { useFrame, useThree } from '@react-three/fiber';
import { Html, useTexture } from '@react-three/drei';
export function Sun({ position = [0, 0, 0], personalInfo, detailsOpen = false }) {
  const sunRef = useRef();
  const { gl } = useThree(); // 获取gl实例
  const [hovered, setHovered] = useState(false);
  // 直接使用 public 文件夹中资源的根相对路径
  const texture = useTexture("/assets/textures/sun.jpg");
  
  // 设置目标缩放比例
  const targetScale = hovered ? 1.1 : 1.0;
  
  // 太阳自转和平滑缩放效果
  useFrame(() => {
    if (sunRef.current) {
      // 自转效果
      sunRef.current.rotation.y += 0.001;
      
      // 平滑过渡到目标缩放比例
      sunRef.current.scale.x += (targetScale - sunRef.current.scale.x) * 0.1;
      sunRef.current.scale.y += (targetScale - sunRef.current.scale.y) * 0.1;
      sunRef.current.scale.z += (targetScale - sunRef.current.scale.z) * 0.1;
    }
  });

  // 点击太阳下载简历函数
  const handleDownloadResume = (event) => {
    event.stopPropagation(); // 阻止事件冒泡，以防触发其他点击事件
    const link = document.createElement('a');
    link.href = '/resume.pdf'; // 简历文件路径
    // 使用 personalInfo 中的 name，如果不存在则默认为“简历”
    const fileName = `${personalInfo?.name || '王裕文'}_简历.pdf`;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <group position={position}>
      {/* 太阳主体 - 添加onClick事件和鼠标样式处理 */}
      <mesh 
        ref={sunRef} 
        onClick={handleDownloadResume}
        onPointerOver={(e) => { 
          e.stopPropagation(); 
          gl.domElement.style.cursor = 'pointer'; 
          setHovered(true); // 设置悬浮状态为true
        }} 
        onPointerOut={(e) => { 
          e.stopPropagation(); 
          gl.domElement.style.cursor = 'auto'; 
          setHovered(false); // 设置悬浮状态为false
        }}
      >
        <sphereGeometry args={[10, 64, 64]} />
        <meshStandardMaterial
          map={texture}
          emissive="#e6e6a0"
          emissiveIntensity={0.4} // 大幅降低发光强度
          toneMapped={true} // 启用色调映射，减少过曝效果
        />
      </mesh>

      {/* 主光源 - 降低强度 */}
      <pointLight intensity={1.2} distance={250} color="#f8f8d0" />
      
      {/* 个人信息标签 */}
      <Html position={[0, 15, 0]} center transform distanceFactor={25} 
          className={`sun-html-element ${detailsOpen ? 'blur-effect' : ''}`}>
        <div className={`name-tag sun-name-tag ${detailsOpen ? 'blur-effect' : ''}`}>
          <h1>{personalInfo?.name || "王裕文"}</h1>
        </div>
      </Html>


    </group>
  );
}